import React, { Component } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Button } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom'
import find from '../../assets/img/sidebar/find.svg'
import people from '../../assets/img/sidebar/people.svg'
import message from '../../assets/img/sidebar/message.svg'
import feeds from '../../assets/img/sidebar/feeds.svg'
import settings from '../../assets/img/sidebar/settings.svg'
import help from '../../assets/img/sidebar/help.svg'
import logout from '../../assets/img/sidebar/logout.svg'
import visitors from '../../assets/img/sidebar/visitors.svg'
import heart from '../../assets/img/sidebar/heart.svg'
import superlike from '../../assets/img/sidebar/superlike.svg'
import profile from '../../assets/img/sidebar/profile.svg'
import like from '../../assets/img/sidebar/like.svg'
import findactive from '../../assets/img/sidebar/findactive.svg'
import peopleactive from '../../assets/img/sidebar/peopleactive.svg'
import messageactive from '../../assets/img/sidebar/messageactive.svg'
import feedsactive from '../../assets/img/sidebar/feedsactive.svg'
import settingsactive from '../../assets/img/sidebar/settingsactive.svg'
import helpactive from '../../assets/img/sidebar/helpactive.svg'
import visitorsactive from '../../assets/img/sidebar/visitorsactive.svg'
import heartactive from '../../assets/img/sidebar/heartactive.svg'
import superlikeactive from '../../assets/img/sidebar/superlikeactive.svg'
import profileactive from '../../assets/img/sidebar/profileactive.svg'
import likeactive from '../../assets/img/sidebar/likeactive.svg'
import imagelogo from '../../assets/img/imagelogo.svg'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { ProfileIcon, ProfileLabelIcon } from './icon';
import ls from "local-storage";
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class SidebarFile extends Component {

  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.state = {
      activeMenuItem: '',
      isOpen: false,
      langKey: ls.get('LangValue'),
      api_url: localStorage.getItem('api_url'),
      ismsgshown: false,
      isreqshown: false,
      islikeshown: false, 
      isvisitorshown: false,
    };
  }

  componentDidMount() {
    if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
      document.body.dir = 'rtl';
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr')
    } else {
      document.body.dir = 'ltr';
      document.body.classList.remove('rtl');
      document.body.classList.add('ltr');
    }

    let data = new FormData();
    data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
    data.append('language', this.state.langKey); 
    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
    axios({
      method: 'post',
      url: this.state.api_url+'webprofile',
      data: data, 
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    }).then(res => {
      if(res.data.status !== 'false') {
        const user_details = res.data.result;

        if (user_details.userstatus === 3 || user_details.userstatus === 0) {
          const cookies = new Cookies();
          cookies.set('onboarded', 'false', { path: "/" });
          cookies.set('signuptab', false);
          localStorage.removeItem('session_token');
          localStorage.removeItem('session_userid');
          localStorage.clear();
          this.props.history.push("/");
        } else {
          var loginstatus = new FormData();
          loginstatus.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
          loginstatus.set('status', '1');
          loginstatus.set('language', this.state.langKey);
          axios({
            method: 'post',
            url: this.state.api_url + 'webonlinestatus',
            data: loginstatus,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
          });

          var user = new FormData();
          user.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
          user.set('language', this.state.langKey); 
          axios({
            method: 'post',
            url: this.state.api_url+'webgetcounts',
            data: user,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
          }).then(res => {
            this.setState({
              notification_count: res.data.result,
            });
            if(this.state.notification_count.message !== '0'){
              this.setState({ ismsgshown: true });
            }
            if(this.state.notification_count.visitors !== '0') {
              this.setState({ isvisitorshown: true });
            }
            if(this.state.notification_count.superlike_request !== '0') {
              this.setState({ isreqshown: true });
            }  
            if(this.state.notification_count.like_request !== '0') {
              this.setState({ islikeshown: true });
            } 
          });
        }
      } else if(res.data.status === 'error' || res.data.status === 'false') {
        this.props.history.push("/");
      } else {
        this.props.history.push("/");
      }
    }).catch(error => {
      this.props.history.push("/");
    });

    this.setActiveMenuItem();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setActiveMenuItem();
    }
  }

  setActiveMenuItem = () => {
    const { pathname } = this.props.location;
    this.setState({ activeMenuItem: pathname });
  };

  toggleDrawer = () => {
    this.setState({ isOpen: true });
  }

  toggleDrawerClose = () => {
    this.setState({ isOpen: false });
  }

  logout = () => {
    var loginstatus = new FormData();
    loginstatus.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
    loginstatus.set('status', '0');
    loginstatus.set('language', this.state.langKey);
    axios({
      method: 'post',
      url: this.state.api_url + 'webonlinestatus',
      data: loginstatus,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    }).then(res => {
      const status = res.data.status;
      if (status === 'true') {
        const cookies = new Cookies();
        cookies.set('onboarded', 'false', { path: "/" });
        cookies.set('signuptab', false);
        localStorage.removeItem('session_token');
        localStorage.removeItem('session_userid');
        localStorage.clear();
        this.props.history.push("/")
        window.location.reload();
      }
    })
  };

  render() {
    const { activeMenuItem, isOpen } = this.state;
    const { t } = this.props;
    return (
      <>
        <div className='sidebar_div'>
          <Sidebar className='sidebar_style'>
            <div className='sidebar_logo'>
              <Link to='/find'>
                <img src={imagelogo} alt="img" />
              </Link>
            </div>
            <Menu>
              <MenuItem className={(activeMenuItem === '/find' || (activeMenuItem === '/nofind' && localStorage.getItem('filter_page') === '2')) ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/find'>
                  <img src={find} alt="img" />
                  <img src={findactive} alt="img" />
                  <span><Trans i18nKey="Find new people">Find new people</Trans></span>
                </NavLink>
              </MenuItem>
              <MenuItem className={(activeMenuItem === '/people' || (activeMenuItem === '/nofind' && localStorage.getItem('filter_page') === '1')) ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/people'>
                  <img src={people} alt="img" />
                  <img src={peopleactive} alt="img" />
                  <span><Trans i18nKey="People near you">People near you</Trans></span>
                </NavLink>
              </MenuItem>
              <MenuItem className={activeMenuItem === '/message' ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/message'>
                  <img src={message} alt="img" />
                  <img src={messageactive} alt="img" />
                  <span><Trans i18nKey="Message">Message</Trans>&nbsp;&nbsp;{this.state.ismsgshown && `(${this.state.notification_count.message})`}</span>
                </NavLink>
              </MenuItem>
              <MenuItem className={activeMenuItem === '/feeds' ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/feeds'>
                  <img src={feeds} alt="img" />
                  <img src={feedsactive} alt="img" />
                  <span><Trans i18nKey="Feeds">Feeds</Trans></span>
                </NavLink>
              </MenuItem>
              <SubMenu icon={<ProfileLabelIcon className="profile_label_svg"/>} label={t("Details")} className='profile_label'>
                <MenuItem className={activeMenuItem === '/profile' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/profile'>
                    <img src={profile} alt="img" />
                    <img src={profileactive} alt="img" />
                    <span><Trans i18nKey="Profile">Profile</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={(activeMenuItem === '/visitor' || (activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '1')) ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/visitor' className={(activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '1') ? 'active' : ''}>
                    <img src={visitors} alt="img" />
                    <img src={visitorsactive} alt="img" />
                    <span><Trans i18nKey="Visitors">Visitors</Trans>&nbsp;&nbsp;{this.state.isvisitorshown && `(${this.state.notification_count.visitors})`}</span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={(activeMenuItem === '/matches' || (activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '2')) ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/matches' className={(activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '2') ? 'active' : ''}>
                    <img src={heart} alt="img" />
                    <img src={heartactive} alt="img" />
                    <span><Trans i18nKey="Matches">Matches</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={(activeMenuItem === '/superlike' || (activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '3')) ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/superlike' className={(activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '3') ? 'active' : ''}>
                    <img src={superlike} alt="img" />
                    <img src={superlikeactive} alt="img" />
                    <span><Trans i18nKey="Super Like">Super Like</Trans>&nbsp;&nbsp;{this.state.isreqshown && `(${this.state.notification_count.superlike_request})`}</span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={(activeMenuItem === '/like' || (activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '4')) ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/like' className={(activeMenuItem === '/nosuperlike' && localStorage.getItem('vmsl_page') === '4') ? 'active' : ''}>
                    <img src={like} alt="img" />
                    <img src={likeactive} alt="img" />
                    <span><Trans i18nKey="Likes">Likes</Trans>&nbsp;&nbsp;{this.state.islikeshown && `(${this.state.notification_count.like_request})`}</span>
                  </NavLink>
                </MenuItem>
              </SubMenu>
              <div className="sidebarborder"></div>
              <MenuItem className={activeMenuItem === '/settings' ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/settings'>
                  <img src={settings} alt="img" />
                  <img src={settingsactive} alt="img" />
                  <span><Trans i18nKey="Settings">Settings</Trans></span>
                </NavLink>
              </MenuItem>
              <MenuItem className={activeMenuItem === '/help' ? 'sidebar_active' : 'sidebar_li'}>
                <NavLink to='/help'>
                  <img src={help} alt="img" />
                  <img src={helpactive} alt="img" />
                  <span><Trans i18nKey="Help">Help</Trans></span>
                </NavLink>
              </MenuItem>
              <MenuItem className={activeMenuItem === '/' ? 'sidebar_active' : 'sidebar_li logout_li'}>
                <div className='logout_lidiv' onClick={this.logout}>
                  <img src={logout} alt="img" />
                  <span><Trans i18nKey="Log out">Log out</Trans></span>
                </div>
              </MenuItem>
            </Menu>
          </Sidebar>
        </div>
        <div className='mobile_Sidebar'>
          <div className='mobile_sidebar_div'>
            <Button onClick={this.toggleDrawer}>
              <svg className="" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 3.75H2.5V5H17.5V3.75Z" fill="#FF0B5E" />
                <path d="M17.5 15H2.5V16.25H17.5V15Z" fill="#FF0B5E" />
                <path d="M17.5 7.5H2.5V8.75H17.5V7.5Z" fill="#FF0B5E" />
                <path d="M17.5 11.25H2.5V12.5H17.5V11.25Z" fill="#FF0B5E" />
              </svg>
            </Button>
            <div className='mobiledrawer_logo'>
              <img src={imagelogo} alt="img" />
              <h4><Trans i18nKey="Kabadate">Kabadate</Trans></h4>
            </div>
          </div>
          <Drawer
            open={isOpen}
            onClose={this.toggleDrawerClose}
            direction='left'
            className='mobiledrawer'

          >
            <Sidebar className='sidebar_style'>
              <div className='sidebar_logo'>
                <Link to='/find'>
                  <img src={imagelogo} alt="img" />
                </Link>
              </div>

              <Menu>
                <MenuItem className={activeMenuItem === '/find' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/find'>
                    <img src={find} alt="img" />
                    <img src={findactive} alt="img" />
                    <span><Trans i18nKey="Find new people">Find new people</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={activeMenuItem === '/people' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/people'>
                    <img src={people} alt="img" />
                    <img src={peopleactive} alt="img" />
                    <span><Trans i18nKey="People near you">People near you</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={activeMenuItem === '/message' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/message'>
                    <img src={message} alt="img" />
                    <img src={messageactive} alt="img" />
                    <span><Trans i18nKey="Message">Message</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={activeMenuItem === '/feeds' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/feeds'>
                    <img src={feeds} alt="img" />
                    <img src={feedsactive} alt="img" />
                    <span><Trans i18nKey="Feeds">Feeds</Trans></span>
                  </NavLink>
                </MenuItem>
                <SubMenu  icon={<ProfileLabelIcon className="profile_label_svg"/>} label="Profile" className='profile_label'>
                  <MenuItem className={activeMenuItem === '/profile' ? 'sidebar_active' : 'sidebar_li'}>
                    <NavLink to='/profile'>
                      <img src={profile} alt="img" />
                      <img src={profileactive} alt="img" />
                      <span><Trans i18nKey="Profile">Profile</Trans></span>
                    </NavLink>
                  </MenuItem>
                  <MenuItem className={activeMenuItem === '/visitor' ? 'sidebar_active' : 'sidebar_li'}>
                    <NavLink to='/visitor'>
                      <img src={visitors} alt="img" />
                      <img src={visitorsactive} alt="img" />
                      <span><Trans i18nKey="Visitors">Visitors</Trans></span>
                    </NavLink>
                  </MenuItem>
                  <MenuItem className={activeMenuItem === '/matches' ? 'sidebar_active' : 'sidebar_li'}>
                    <NavLink to='/matches'>
                      <img src={heart} alt="img" />
                      <img src={heartactive} alt="img" />
                      <span><Trans i18nKey="Matches">Matches</Trans></span>
                    </NavLink>
                  </MenuItem>
                  <MenuItem className={activeMenuItem === '/superlike' ? 'sidebar_active' : 'sidebar_li'}>
                    <NavLink to='/superlike'>
                      <img src={superlike} alt="img" />
                      <img src={superlikeactive} alt="img" />
                      <span><Trans i18nKey="Super Like">Super Like</Trans></span>
                    </NavLink>
                  </MenuItem>
                  <MenuItem className={activeMenuItem === '/like' ? 'sidebar_active' : 'sidebar_li'}>
                    <NavLink to='/like'>
                      <img src={like} alt="img" />
                      <img src={likeactive} alt="img" />
                      <span><Trans i18nKey="Likes">Likes</Trans></span>
                    </NavLink>
                  </MenuItem>
                </SubMenu>
                <MenuItem className={activeMenuItem === '/settings' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/settings'>
                    <img src={settings} alt="img" />
                    <img src={settingsactive} alt="img" />
                    <span><Trans i18nKey="Settings">Settings</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={activeMenuItem === '/help' ? 'sidebar_active' : 'sidebar_li'}>
                  <NavLink to='/help'>
                    <img src={help} alt="img" />
                    <img src={helpactive} alt="img" />
                    <span><Trans i18nKey="Help">Help</Trans></span>
                  </NavLink>
                </MenuItem>
                <MenuItem className={activeMenuItem === '/' ? 'sidebar_active' : 'sidebar_li logout_li'}>
                  <NavLink to='/'>
                    <img src={logout} alt="img" />
                    <span><Trans i18nKey="Log out">Log out</Trans></span>
                  </NavLink>
                </MenuItem>
              </Menu>
            </Sidebar>
          </Drawer>
        </div>
      </>

    );
  }
}

export default withTranslation("translations")(withRouter(SidebarFile));